import { FIELD_TYPES } from "constants/template-field-type";
import { PRODUCT_OPTIONS } from "constants/products";

const FILTERED_PRODUCTS = PRODUCT_OPTIONS.slice(0, 2);

export default {
  type: FIELD_TYPES.NESTED,
  label: "Whats New Items List",
  fields: {
    productFilterValue: {
      label: "Product Filter Value",
      type: FIELD_TYPES.COMBO,
      options: FILTERED_PRODUCTS
    },
    hideProductFilter: {
      label: "Hide Product Filter",
      type: FIELD_TYPES.BOOLEAN
    }
  }
};
